import styled from "@emotion/styled";
import { Toys } from "@mui/icons-material";
import { Container, Typography } from "@mui/material";
import {Grid} from "@mui/material";

const MainContainer = styled(Container)`
    background-image:url("./assets/tokenbg.png");
    background-size:cover;
    background-position:center center;
    background-repeat:no-repeat;
    margin-top:100px;
    @media (max-width: 767px){
        background-size:unset;
        margin-top:50px;
    }
    @media (max-width: 1024px) and (min-width: 768px){
        background-size:cover;
    }
    @media (min-width: 2000px){
        background-size:contain;
    }
`
const Heading = styled(Typography)`
    font-family: 'ManjariBold';
    font-size: 70px;
    color: #2A3382;
    font-weight: 900;    
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(./assets/tokenheadingbg.png);
    padding: 30px 50px;
    @media (max-width:767px){
        font-size:40px;
        padding: 40px 40px 0px 40px;
    }
    @media (max-width:1000px) and (min-width: 768px){
        font-size:40px;
        padding: 30px 50px;
    }
`
const P = styled(Typography)`
    color:#27233A;
    font-family:SegoeRegular;
    font-size:15;
    text-align:center;
`
const WrapperGrid = styled(Grid)`
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items:center;
`
const HeadingWrapper = styled.div`
    background-mage:;
`
const LinksContainer = styled(Grid)`

`
const BottomText = styled(Typography)`
    font-family:GaeguBold;
    font-size:25px;
    color:#2A3382;
    text-transform:uppercase;
    @media (max-width:767px){
        font-size:18px;
    }
    
`
const LastGrid = styled(Grid)`
    margin-top:100px;
    @media (max-width: 1024px) and (min-width: 600px){
        margin-top:10px;
    }
    @media (max-width:600px){
        display: flex;
        justify-content: center;
        margin-top:20px;
    }
`

export default function Tokenomics(){
    return(
        <MainContainer maxWidth="xxl" id="tokenomics">
            <WrapperGrid container spacing={2}>
                <Grid item xs={12}>
                    <HeadingWrapper>
                        <Heading variant="h1">Tokenomics</Heading>
                    </HeadingWrapper>
                </Grid>
                <Grid item xs={12}>
                    <BottomText>Disclosures and Legalease</BottomText>
                </Grid>
                <Grid item xs={12} sm={10} md={6} lg={6} xl={4}>
                    <P>Please note that investing in cryptocurrency carries inherent risks.
                         The Shih Tzu team urges all users to conduct thorough research and
                          exercise caution when participating in the cryptocurrency market.
                           While we strive to provide a secure and reliable platform, market
                            volatility and unforeseen circumstances can impact token values.
                             By engaging with Shih Tzu, you acknowledge and accept the potential 
                             risks involved. Our team will continue to work diligently to deliver 
                             the best experience possible, but we cannot guarantee
                         financial gains or the absence of market fluctuations. Always make informed decisions and invest responsibly.
                        </P>
                </Grid>
                <LastGrid container item xs={12} sm={10} md={6} lg={6} xl={4}>
                    <BottomText style={{fontSize:'16px'}}>CONTRACT:  0x05231fAb6597e4388Ad86f7e9C276531dd8FAE0C</BottomText>
                </LastGrid>
            </WrapperGrid>
        </MainContainer>
    );
}